import { useUnit } from 'effector-react'
import { useEffect } from 'react'
import { lastWatchedContentFeatureModel } from '~/features/last-watched-content'

/**
 * Hook to update last watched content
 */
interface UseLastWatchedContentProps {
  title?: string
  autoplayTrailer?: boolean
}
export function useLastWatchedContent({
  title,
  autoplayTrailer,
}: UseLastWatchedContentProps) {
  const updateLastWatchedContent = useUnit(
    lastWatchedContentFeatureModel.updateLastWatchedContent
  )

  useEffect(() => {
    if (!title || autoplayTrailer) return
    updateLastWatchedContent(title)
  }, [title, updateLastWatchedContent, autoplayTrailer])
}
